import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { DealerEmployee } from 'src/app/models/dealer-employee.model';
import { DealersService } from 'src/app/services/dealers.service';

@Component({
  selector: 'app-admins-dialog',
  templateUrl: './admins-dialog.component.html',
  styleUrls: ['./admins-dialog.component.scss']
})
export class AdminsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AdminsDialogComponent>, private dealersService : DealersService) { }

  isAdminsLoading = false;
  pscAdmins: DealerEmployee[] = [];
  pscAdminColumns: ColumnDefinition[] = [
    { columnDef: 'gmvssmadminroledn', header: 'Admin Type', cell: (w: any) => `${w.gmvssmadminroledn}` },
    { columnDef: 'name', header: 'Name', cell: (w: any) => `${w.name}` },
    { columnDef: 'email', header: 'Contact', cell: (w: any) => `${w.mail}` }
  ];

  ngOnInit(): void {
    this.getPSCAdmins();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getPSCAdmins() {
    this.isAdminsLoading = true;
    this.dealersService.getEmployeesForDealership().subscribe((res : DealerEmployee[]) => {
      this.pscAdmins = res;
      this.isAdminsLoading = false;
    })
  }

}
